export const model = [
  {
    'id': 'users',
    'title': 'main.users',
    'type': 'item',
    'icon': 'people',
    'url': '/pages/users',
    'show': true,
  },
  {
    'id': 'events',
    'title': 'main.events',
    'type': 'collapse',
    'icon': 'today',
    'url': '/pages/event',
    'show': true,
    'children': [
      {
        'id': 'event',
        'title': 'main.all_event',
        'type': 'item',
        'icon': 'event_note',
        'url': '/pages/event',
        'show': true,
      },
      {
        'id': 'running',
        'title': 'main.running',
        'type': 'item',
        'icon': 'today',
        'url': '/pages/events/running',
        'show': true,
      },
      {
        'id': 'archive',
        'title': 'main.archive_event',
        'type': 'item',
        'icon': 'today',
        'url': '/pages/events/archive',
        'show': true,
      },
      {
        'id': 'deletedEvents',
        'title': 'main.deletedEvents',
        'type': 'item',
        'icon': 'today',
        'url': '/pages/events/deleted',
        'show': true,
      },
      {
        'id': 'calendar',
        'title': 'main.calendar',
        'type': 'item',
        'icon': 'calendar_today',
        'url': '/pages/calendar',
        'show': true,
      },
      {
        'id': 'released-event',
        'title': 'main.released_event',
        'type': 'item',
        'icon': 'today',
        'url': '/pages/released-event',
        'show': true,
      }
    ]
  },
  {
    'id': 'marketplaces',
    'title': 'main.marketplace',
    'type': 'item',
    'icon': 'apps',
    'url': '/pages/marketplaces',
    'show': true
  },
  {
    'id': 'eLearning',
    'title': 'main.eLearning',
    'type': 'item',
    'icon': 'video_library',
    'url': '/pages/eLearning',
    'show': true
  },
  {
    'id': 'learningPaths',
    'title': 'main.learning_paths',
    'type': 'item',
    'icon': 'apps',
    'url': '/pages/learningPaths',
    'show': true
  },
  {
    'id': 'blog',
    'title': 'main.blog',
    'type': 'item',
    'icon': 'dashboard',
    'url': '/pages/blog',
    'show': true
  },
  {
    'id': 'frontusers',
    'title': 'main.community',
    'type': 'collapse',
    'icon': 'supervised_user_circle',
    'url': '/pages/frontusers',
    'show': true,
    'children': [
      {
        'id': 'frontVerify',
        'title': 'main.frontuser',
        'type': 'item',
        'icon': 'how_to_reg',
        'url': '/pages/frontusers',
        'show': true,
      },
      {
        'id': 'frontNoVerify',
        'title': 'frontUser.frontNoVerify',
        'type': 'item',
        'icon': 'person_add',
        'url': '/pages/frontusersnoactive',
        'show': true
      },
      {
        'id': 'delete-request',
        'title': 'frontUser.deleteRequest',
        'type': 'item',
        'icon': 'person_remove',
        'url': '/pages/delete-request',
        'show': true
      }
    ]
  },
  {
    'id': 'recommendation',
    'title': 'main.recommendation',
    'type': 'collapse',
    'icon': 'thumb_up',
    'show': true,
    'children': [
      {
        'id': 'recommendation-event',
        'title': 'main.events',
        'type': 'item',
        'icon': 'today',
        'url': '/pages/recommendation/recommendation-event',
        'show': true
      },
      {
        'id': 'recommendation-blog',
        'title': 'main.blog',
        'type': 'item',
        'icon': 'dashboard',
        'url': '/pages/recommendation/recommendation-blog',
        'show': true
      },
      {
        'id': 'recommendation-elearning',
        'title': 'main.eLearning',
        'type': 'item',
        'icon': 'apps',
        'url': '/pages/recommendation/recommendation-elearning',
        'show': true
      },
      {
        'id': 'favorite',
        'title': 'main.favorite',
        'type': 'item',
        'icon': 'star',
        'url': '/pages/recommendation/favorite',
        'show': true
      },
    ]
  },
  {
    'id': 'communications',
    'title': 'main.communications',
    'type': 'collapse',
    'icon': 'email',
    'url': '/pages/communications',
    'show': true,
    'children': [
      {
        'id': 'communicationsSent',
        'title': 'main.communicationsSent',
        'type': 'item',
        'icon': 'drafts',
        'url': '/pages/communications',
        'show': true,
      },
      {
        'id': 'communicationsTemplates',
        'title': 'main.communicationsTemplate',
        'type': 'item',
        'icon': 'file_copy',
        'url': '/pages/templates',
        'show': true,
      }
    ]
  },
  {
    'id': 'recommend',
    'title': 'main.recommend',
    'type': 'collapse',
    'icon': 'add',
    'show': true,
    'children': [
      {
        'id': 'recommendEvent',
        'title': 'main.events',
        'type': 'item',
        'icon': 'today',
        'url': '/pages/recommendEvent',
        'show': true,
      },
      {
        'id': 'recommendBlog',
        'title': 'main.blog',
        'type': 'item',
        'icon': 'dashboard',
        'url': '/pages/recommendBlog',
        'show': true,
      },
      {
        'id': 'recommendElearning',
        'title': 'main.eLearning',
        'type': 'item',
        'icon': 'apps',
        'url': '/pages/recommendElearning',
        'show': true,
      }
    ]
  },
  // {
  //   'id': 'dynamicForm' ,
  //   'title': 'main.dynamicForm' ,
  //   'type': 'item' ,
  //   'icon': 'dashboard' ,
  //   'url': '/pages/dynamicForm' ,
  //   'show': true
  // } ,
  {
    'id': 'news',
    'title': 'main.news',
    'type': 'item',
    'icon': 'mail',
    'url': '/pages/news',
    'show': true
  },
  {
    'id': 'setting',
    'title': 'main.setting',
    'type': 'collapse',
    'icon': 'settings',
    'show': true,
    'children': [
      {
        'id': 'platforms',
        'title': 'main.platforms',
        'type': 'item',
        'icon': 'apps',
        'url': '/pages/settings/platforms',
        'show': true,
      },
      {
        'id': 'modules',
        'title': 'main.modules',
        'type': 'item',
        'icon': 'apps',
        'url': '/pages/settings/modules',
        'show': true,
      },
      // {
      //   'id': 'spaces' ,
      //   'title': 'main.eLearning' ,
      //   'type': 'item' ,
      //   'icon': 'apps' ,
      //   'url': '/pages/settings/spaces' ,
      //   'show': true ,
      // } ,
      {
        'id': 'marketplaceCategory',
        'title': 'main.marketplaceCategory',
        'type': 'item',
        'icon': 'apps',
        'url': '/pages/settings/marketplaceCategory',
        'show': true,
      },
      {
        'id': 'learn-category-menu',
        'title': 'main.eLearning',
        'type': 'collapse',
        'icon': 'settings',
        'show': true,
        'children': [
          {
            'id': 'spaces',
            'title': 'main.space_and_boards',
            'type': 'item',
            'icon': 'apps',
            'url': '/pages/settings/spaces',
            'show': true,
          },
          {
            'id': 'learn-category',
            'title': 'main.learnCategories',
            'type': 'item',
            'icon': 'apps',
            'url': '/pages/settings/learn-category',
            'show': true,
          },
          {
            'id': 'share-links',
            'title': 'main.shareLinks',
            'type': 'item',
            'icon': 'apps',
            'url': '/pages/settings/share-links',
            'show': true,
          }
        ]
      },
      {
        'id': 'competency' ,
        'title': 'main.competencies' ,
        'type': 'item' ,
        'icon': 'psychology' ,
        'url': '/pages/settings/competency' ,
        'show': true ,
      } ,
      {
        'id': 'orgCompetency' ,
        'title': 'main.competencies' ,
        'type': 'item' ,
        'icon': 'psychology' ,
        'url': '/pages/settings/orgCompetency' ,
        'show': true ,
      } ,
      {
        'id': 'organizer-settings',
        'title': 'main.organizer',
        'type': 'item',
        'icon': 'how_to_reg',
        'url': '/pages/settings/organizer-settings',
        'show': true,
      },
      {
        'id': 'event-settings',
        'title': 'main.eventType',
        'type': 'item',
        'icon': 'event_available',
        'url': '/pages/settings/event-settings',
        'show': true,
      },
      {
        'id': 'level-settings',
        'title': 'main.level',
        'type': 'item',
        'icon': 'format_list_numbered',
        'url': '/pages/settings/level-settings',
        'show': true,
      },
      {
        'id': 'target-group',
        'title': 'main.targetGroup',
        'type': 'item',
        'icon': 'format_list_numbered',
        'url': '/pages/settings/target-group',
        'show': true,
      },
      {
        'id': 'group',
        'title': 'main.group',
        'type': 'item',
        'icon': 'format_list_numbered',
        'url': '/pages/settings/group',
        'show': true,
      },
      {
        'id': 'function',
        'title': 'main.function',
        'type': 'item',
        'icon': 'transfer_within_a_station',
        'url': '/pages/settings/function',
        'show': true,
      },
      {
        'id': 'blogType',
        'title': 'main.blogType',
        'type': 'item',
        'icon': 'format_list_numbered',
        'url': '/pages/settings/blogType',
        'show': true,
      },
      {
        'id': 'confession',
        'title': 'main.confession',
        'type': 'item',
        'icon': 'location_city',
        'url': '/pages/settings/confession',
        'show': true,
      },
      {
        'id': 'dynamicData',
        'title': 'main.dynamicData',
        'type': 'item',
        'icon': 'spellcheck',
        'url': '/pages/settings/dynamicData',
        'show': true,
      },
      {
        'id': 'tag',
        'title': 'main.tag',
        'type': 'item',
        'icon': 'tag',
        'url': '/pages/settings/tag',
        'show': true,
      },
      {
        'id': 'email-builder',
        'title': 'main.email-builder',
        'type': 'item',
        'icon': 'email',
        'url': '/pages/settings/email-builder',
        'show': true,
      },
      {
        'id': 'event-cantons',
        'title': 'main.cityMergeTool',
        'type': 'item',
        'icon': 'format_list_numbered',
        'url': '/pages/settings/event-cantons',
        'show': true,
      },
      {
        'id': 'default',
        'title': 'main.default',
        'type': 'item',
        'icon': 'list_alt',
        'url': '/pages/settings/default',
        'show': true,
      },
      // {
      //   'id': 'projectSettings' ,
      //   'title': 'main.projectSettings' ,
      //   'type': 'item' ,
      //   'icon': 'list_alt' ,
      //   'url': '/pages/settings/projectSettings' ,
      //   'show': true ,
      // },
      // {
      //   'id': 'emailEditor' ,
      //   'title': 'main.emailEditor' ,
      //   'type': 'item' ,
      //   'icon': 'email' ,
      //   'url': '/pages/settings/emailEditor' ,
      //   'show': true ,
      // },
      {
        'id': 'genderType',
        'title': 'gender_type',
        'type': 'item',
        'icon': 'manage_accounts',
        'url': '/pages/settings/genderType',
        'show': true,
      }
    ]
  },
  {
    'id': 'matrix',
    'title': 'main.matrix',
    'type': 'collapse',
    'icon': 'apps',
    'show': true,
    'children': [
      {
        'id': 'matrixPlatforms',
        'title': 'main.platforms',
        'type': 'item',
        'icon': 'apps',
        'url': '/pages/matrix/platforms',
        'show': true,
      },
      {
        'id': 'matrixModules',
        'title': 'main.modules',
        'type': 'item',
        'icon': 'apps',
        'url': '/pages/matrix/mat-modules',
        'show': true,
      }
    ]
  },
  {
    'id': 'marketplace',
    'title': 'main.marketplace',
    'type': 'collapse',
    'icon': 'apps',
    'show': true,
    'children': [
      {
        'id': 'org-platform',
        'title': 'main.platforms',
        'type': 'item',
        'icon': 'apps',
        'url': '/pages/marketplace/org-platform',
        'show': true,
      },
      {
        'id': 'org-modules',
        'title': 'main.modules',
        'type': 'item',
        'icon': 'apps',
        'url': '/pages/marketplace/org-modules',
        'show': true,
      }
    ]
  },
  {
    'id': 'statistic',
    'title': 'main.statistic',
    'type': 'item',
    'icon': 'timeline',
    'url': '/pages/statistic',
    'show': true
  },
  {
    'id': 'manager',
    'title': 'main.manager',
    'type': 'collapse',
    'icon': 'assignment',
    'show': true,
    'children': [
      // {
      //   'id': 'documents' ,
      //   'title': 'main.documents' ,
      //   'type': 'item' ,
      //   'icon': 'description' ,
      //   'url': '/pages/manager/documents' ,
      //   'show': true ,
      // } ,
      {
        'id': 'pictures',
        'title': 'main.pictures',
        'type': 'item',
        'icon': 'image',
        'url': '/pages/manager/pictures',
        'show': true
      },
      // {
      //   'id': 'tasks' ,
      //   'title': 'main.tasks' ,
      //   'type': 'item' ,
      //   'icon': 'ballot' ,
      //   'url': '/pages/manager/tasks' ,
      //   'show': true ,
      // },
      {
        'id': 'whatsapp',
        'title': 'main.whatsapp',
        'type': 'item',
        'icon': 'call',
        'url': '/pages/manager/whatsapp',
        'show': true,
      },
      {
        'id': 'budget',
        'title': 'main.budget',
        'type': 'item',
        'icon': 'description',
        'url': '/pages/manager/budget',
        'show': true,
      },
      {
        'id': 'personnel',
        'title': 'main.personnel',
        'type': 'item',
        'icon': 'description',
        'url': '/pages/manager/personnel',
        'show': true,
      },
      {
        'id': 'logsHistory',
        'title': 'main.logsHistory',
        'type': 'item',
        'icon': 'description',
        'url': '/pages/manager/logsHistory',
        'show': true,
      }
    ]
  },
  {
    'id': 'canton',
    'title': 'main.canton',
    'type': 'item',
    'icon': 'place',
    'url': '/pages/canton',
    'show': true
  },
  {
    'id': 'organization',
    'title': 'main.organization',
    'type': 'item',
    'icon': 'account_balance',
    'url': '/pages/organization',
    'show': true
  },
  {
    'id': 'tutorial',
    'title': 'main.tutorial',
    'type': 'item',
    'icon': 'video_library',
    'url': '/pages/tutorial',
    'show': true
  }
];

